import { Flex, Spinner as ChakraSpinner } from '@chakra-ui/react';

import { HEADER_HEIGHT } from 'projectConstants';
import { accent, neutral } from 'styles/revampTokens';

/**
 * The default background used to be `gradient.body` — the pre-revamp dark
 * violet wash — which every call site inherited, so a plain data fetch covered
 * the app in purple. Loading chrome sits on the neutral canvas like the rest of
 * the revamp; the accent is left for the spinner, which is genuinely active.
 */
const Spinner = () => (
  <ChakraSpinner
    thickness='3px'
    speed='0.7s'
    emptyColor={neutral.border}
    color={accent.solid}
    size='lg'
  />
);

interface Properties {
  isGridElement?: boolean;
  bgColor?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
  flags?: any;
}

const FullScreenLoader = ({ isGridElement, bgColor, height, width, style }: Properties) => {
  return (
    <>
      {isGridElement ? (
        <Flex
          style={style}
          data-testid='loader-component'
          h={height || `calc(100vh - ${HEADER_HEIGHT})`}
          w={width}
          position='absolute'
          align='center'
          left='50%'
          transform='translateX(-50%)'
        >
          <Spinner />
        </Flex>
      ) : (
        <Flex
          style={style}
          data-testid='loader-component'
          justify='center'
          align='center'
          h={height || `calc(100vh - ${HEADER_HEIGHT})`}
          w={width}
          bg={bgColor || neutral.canvas}
        >
          <Spinner />
        </Flex>
      )}
    </>
  );
};

export default FullScreenLoader;
